import {Component, Inject, OnInit} from '@angular/core';
import {BsModalRef } from "ngx-bootstrap";
import {DomSanitizer} from "@angular/platform-browser";
import {Subject} from "rxjs";
import {CommonService} from "@app/services"
import {environment} from "@app/utils/get-api-url";
declare var _: any;

@Component({
  selector: 'app-pdf-view',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {

  public onClose: Subject<boolean>;

  data: any;
  pdfURL: any;
  isCopy = false;
  active_slide = 1;
  print_and_post_message :string;
  print_and_post_error_message :string;
  supports_copy = false;
  supports_print_post = false;
  tableType: any;
  tablePkid: any;
  screen: string='';
  showEmailButton: boolean = false;
  fileListTableType: number;
  fileListTablePkid: number;
  emailSubject: string;
  emailMessage: string;
  showPrint: boolean = true;

  constructor(
      public sidePanelModalRef: BsModalRef,
      private sanitizer: DomSanitizer,
      private commonService: CommonService,
      @Inject('$scope') private ajsScope,
      @Inject('ajsState') private ajsState,
      @Inject('emailService') private emailService,
      public bsModalRef: BsModalRef,
  ) { }

  ngOnInit() {
      this.onClose = new Subject();
      if(this.data.supports_copy) this.supports_copy = this.data.supports_copy;
      if(this.data.supports_print_post) this.supports_print_post = this.data.supports_print_post;
      this.tableType = this.data.tableType;
      this.tablePkid = this.data.tablePkid;
      let url = environment.apiPrefixPath + this.data.url;
      this.pdfURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.print_and_post_message = null;
      this.print_and_post_error_message = null;
      this.commonService.getCheckPrintPostCredits()
          .subscribe(data =>{
              this.print_and_post_error_message = data.error;
          }, error =>{
              console.log(error);
          });
      this.ajsScope.$on('email:email_sent', () => {
          this.onClose.next(true);
      });
  }

    print() {
        const base = environment.apiPrefixPath + this.data.url;
        const sep = this.data.url.indexOf('?') >= 0 ? '&' : '?';
        const url = base + sep + 'type=print';
        window.open(url,'_blank');
        // this.onClose.next(true);
        // this.sidePanelModalRef.hide();
    }

    checkSupportCopy(isCopy) {
            this.isCopy = isCopy;
    }

    slideInView(slide) {
        this.active_slide = slide;
    }

    printPost() {
        this.commonService.printAndPostService(this.tableType,this.tablePkid)
            .subscribe(data =>{
                if (data == 'sendPrintAndPostError'){
                    this.print_and_post_message = null;
                }else{
                    this.print_and_post_error_message = null;
                }
            }, error =>{
                console.log(error);
            });
    }

    triggerSendEmail($event) {
        $event.preventDefault();
        var new_email = this.emailService.generateBlankEmailData(),
            new_obj = {},
            clone_obj = _.extend(new_obj, new_email);
            clone_obj.from_addresses_url = '/get_from_emails';
            clone_obj.recipient_addresses_url = '/get_customer_emailaddresses?id=' + this.data.customerId + '&type=all_email';
            clone_obj.subject = this.emailSubject;
            clone_obj.message = this.emailMessage;
        clone_obj.relatedObjectId = this.data.id;

        if (this.data && this.data.tablePkid) {
            clone_obj.relatedObjectId = this.data.tablePkid;
        }
        if (this.data && this.data.tableType) {
            clone_obj.relatedObjectType = this.data.tableType;
        }

        if(this.screen=='jobCertificate') {
            clone_obj.relatedObjectId = this.data.id;
            clone_obj.relatedObjectType = (this.data.certificateType == 69) ? this.data.pat_type : 47;    // for Certificate lookup id
            let name = this.data.type.replace(/,/g, '');
            if (this.data.certificateType == 69)       // for pat certificate lookup table type
            {
                clone_obj.attached_files = [
                    {
                        id: "PATCERTIFICATE|" + name + "|" + this.data.id + "|" + this.data.pat_type,
                        file_name: "Job " + name + ". " + this.data.number,
                        file_size: 0,
                        type: 'generated'
                    }
                ];
            } else {
                clone_obj.attached_files = [
                    {
                        id: "CERTIFICATE|" + name + "|" + this.data.id + "|" + this.data.number,
                        file_name: "Job " + name + ". " + this.data.number,
                        file_size: 0,
                        type: 'generated'
                    }
                ];
            }
            this.fileListTableType = 31;
            this.fileListTablePkid = this.data.jobId;
        } else if (this.screen == 'jobReport') {
            // Keep parity with legacy job view: pre-attach generated Job Report PDF by default.
            this.fileListTableType = this.data.fileListTableType;
            this.fileListTablePkid = this.data.fileListTablePkid;
            clone_obj.relatedObjectType = 60;
            clone_obj.relatedObjectId = this.data.fileListTablePkid || this.data.tablePkid || this.data.id;
            clone_obj.attached_files = [
                {
                    id: 'JOBREPORT|' + this.data.customerId + '|' + this.fileListTablePkid + '|60',
                    file_name: 'Job No. ' + this.fileListTablePkid,
                    file_size: 0,
                    type: 'generated'
                }
            ];
        } else if (this.screen == 'manufactureJobReport') {
            // Mirror legacy behavior: generated job report is attached by default.
            this.fileListTableType = this.data.fileListTableType;
            this.fileListTablePkid = this.data.fileListTablePkid;
            clone_obj.relatedObjectType = this.data.tableType || 536;
            clone_obj.relatedObjectId = this.data.fileListTablePkid || this.data.tablePkid || this.data.id;
            clone_obj.attached_files = [
                {
                    id: 'JOBREPORT|' + this.data.customerId + '|' + this.fileListTablePkid + '|' + clone_obj.relatedObjectType,
                    file_name: 'Job No. ' + this.fileListTablePkid,
                    file_size: 0,
                    type: 'generated'
                }
            ];
        } else {
            if (this.data.tableType) {
                clone_obj.relatedObjectType = this.data.tableType;
            }
            this.fileListTableType = this.data.fileListTableType;
            this.fileListTablePkid = this.data.fileListTablePkid;
        }
        clone_obj.attachments_url = '/get_attached_files_list?tableType='+this.fileListTableType+'&id=' + this.fileListTablePkid;
        this.ajsScope.$broadcast('email:createNew', clone_obj);

    }


}
